import { HttpClient, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { SharedGrpcModule } from '@libs/core/grpc/shared-grpc.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CORALOGIX_ANONYMOUS_INITIALIZER } from '@libs/utility-monitoring/providers/coralogix-anonymous-initializer.provider';
import { CoralogixErrorHandlerService } from '@libs/utility-monitoring/services/coralogix-error-handler.service';
import { APP_STORAGE, LocalStorageService } from '@libs/utility-storage';
import { PaymentBrandingService } from './services/payment-branding/payment-branding.service';
import { provideFeatureFlags } from '@libs/utility-feature-flags/+state/feature-flags-state.module';
import { multiHttpLoaderFactory } from '@libs/shared/utilities/providers/translate-multi-http-loader.factory';
import { TRANSLATE_FILE_DIRS } from '@libs/shared/utilities/tokens/translate-file-dirs.token';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    importProvidersFrom(BrowserModule, SharedGrpcModule),

    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: multiHttpLoaderFactory,
        deps: [HttpClient, TRANSLATE_FILE_DIRS],
      },
    }),
    { provide: APP_STORAGE, useClass: LocalStorageService },
    CORALOGIX_ANONYMOUS_INITIALIZER,
    {
      provide: ErrorHandler,
      useClass: CoralogixErrorHandlerService,
    },
    provideFeatureFlags(),
    provideAppInitializer(() => {
      const initializerFn = (
        (PaymentBrandingService: PaymentBrandingService) => () =>
          PaymentBrandingService.initializeBranding()
      )(inject(PaymentBrandingService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = (
        (translateService: TranslateService) => () =>
          translateService.addLangs(['en', 'zh'])
      )(inject(TranslateService));
      return initializerFn();
    }),
  ],
};

export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
